export const SelectPostPlaceholder = () => (
    <div
        className="grid grid-cols-1 gap-4 px-0.75 @sm:grid-cols-1 @md:grid-cols-2 @lg:grid-cols-3"
        data-testid="loading-state">
        {Array.from({ length: 9 }).map((_, index) => (
            <div
                key={index}
                className="w-full rounded-lg @sm:col-span-1 @md:col-span-1 @lg:col-span-1">
                <div className="aspect-1 animate-pulse rounded-md bg-gray-100" />
            </div>
        ))}
    </div>
);
